import { Company, MarketCode } from '@homesusa/core';
import { AuthCookiesManager } from './cookies-manager';

export const redirectToUrl = ({
  currentMarket,
  currentCompany,
  url
}: {
  currentMarket: MarketCode;
  currentCompany?: Company;
  url: string;
}): void => {
  if (currentCompany) {
    AuthCookiesManager.setCompany(currentCompany);
  } else {
    AuthCookiesManager.setMarket(currentMarket);
  }

  window.location.href = url;
};
